import styled from 'styled-components'
import Link from 'next/link'
import { SecondaryButton } from 'common/button'
import Wrapper from 'common/wrapper'
import { Typography } from 'common/typography'
import { useProjects, useProject } from 'querys/projects'
import useNearScreen from 'hooks/use-near-screen'
import NewProjectCard from './new-project-card'

const NewProjectsGridStyled = styled.section`
  padding: 0 0 40px 0;
  position: relative;
  h2 {
    max-width: 600px;
  }
  .new-projects {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 450px);
    row-gap: 24px;
    column-gap: 24px;
    padding: 16px 0 24px;
  }
  @media (min-width: 768px){
    .cta-container {
      display: flex;
      justify-content: center;
    }
    padding: 0 0 80px 0;
    .new-projects {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 450px);
      padding: 32px 0;
    }
  }
  @media (min-width: 1024px){
  }
`

function NewProjectsGrid({ similar }) {
  const { data: project } = useProject()
  const params = {
    size: 4,
  }
  if (similar) {
    params.size = 5
    params.level = project.level
    params.type = project.type
    if (project.challenge) {
      params.property = 'challenge'
    }
    if (project.is_free) {
      params.property = 'is_free'
    }
  }
  const { data, isLoading, isError } = useProjects(params)
  const [show, element] = useNearScreen({ rootMargin: '0px 0px 1200px 0px' })
  if (isLoading || isError) return null
  const { results } = data
  let newProjects = results
  if (similar && project) {
    newProjects = newProjects.filter(({ slug }) => slug !== project.slug).slice(0, 4)
  }
  return (
    <NewProjectsGridStyled role="region" aria-label="Los proyectos mas recientes">
      <Wrapper maxWidth={1206}>
        {similar ? (
          <Typography color="var(--baseNeutral)" small="headline5" large="headline4" as="h2">
            Proyectos similares
          </Typography>
        ) : (
          <Typography color="var(--baseNeutral)" small="headline5" large="headline3" as="h2">
            Proyectos para los que no se rinden
          </Typography>
        )}
        <ul className="new-projects" ref={element}>
          {
            newProjects
              .map((newProject) => <NewProjectCard key={newProject.uuid} {...newProject} />)
          }
        </ul>
        <div className="cta-container">
          <Link href="/proyectos/todos" passHref>
            <SecondaryButton fullWidth fitContent id="see-all-projects">
              Ver todos los proyectos
            </SecondaryButton>
          </Link>
        </div>
      </Wrapper>
    </NewProjectsGridStyled>
  )
}

export default NewProjectsGrid
